<script setup lang="ts">
import { CompanyUserBasicResourceDto } from '@/munio/api/data'
import { trans } from '@/munio/i18n'
import Company from '@component/CompanySearch/Company.vue'

const props = defineProps<{
  invite: {
    element: CompanyUserBasicResourceDto
  }
}>()

const company = props.invite.element.company!
const relationship = props.invite.element.relationship
</script>

<template>
  <p>{{ trans('You have been invited to join') }}:</p>

  <Company :company="company" class="border-2 border-default rounded">
    <div class="flex flex-col gap-y-1 items-end">
      <span>{{ trans('Relationship') }}</span>
      <span class="mdl-label">{{ relationship.name }}</span>
    </div>
  </Company>

  <slot></slot>
</template>
